export default __webpack_public_path__ + "static/media/optometry.b9cdf771.png";